module.exports = __webpack_public_path__ + "img/tb_logo2.184eba39.png";